// src/components/StartDateEdit.js
import React, { useState } from 'react';
import { apiFetch } from '../utils/apiFetch';
import '../styles/StartDateEdit.css';

const StartDateEdit = ({ currentStartDate, onClose, onSuccess }) => {
    const [startDate, setStartDate] = useState(currentStartDate || '');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!startDate) {
            setError('시작일을 선택해주세요.');
            return;
        }

        const today = new Date().toISOString().split('T')[0];
        if (startDate > today) {
            setError('시작일은 오늘 이전 날짜여야 합니다.');
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            const response = await apiFetch('/members/start-date', {
                method: 'PUT',
                body: JSON.stringify({ startDate })
            });

            if (response.ok) {
                const result = await response.json();
                onSuccess(result.data);
                onClose();
            } else {
                const errorData = await response.json();
                setError(errorData.errorMessage || errorData.message || '시작일 수정에 실패했습니다.');
            }
        } catch (error) {
            console.error('시작일 수정 오류:', error);
            setError('네트워크 오류가 발생했습니다.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleModalClick = (e) => {
        if (e.target.classList.contains('start-date-overlay')) {
            onClose();
        }
    };

    return (
        <div className="start-date-overlay" onClick={handleModalClick}>
            <div className="start-date-modal">
                <div className="modal-header">
                    <h3>커플 시작일 수정</h3>
                    <button onClick={onClose} className="modal-close-btn">✕</button>
                </div>

                <div className="modal-content">
                    <p className="modal-description">
                        실제 커플이 된 날짜로 수정해주세요.
                    </p>

                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="start-date-form">
                        <div className="form-group">
                            <label htmlFor="startDate">시작일</label>
                            <input
                                type="date"
                                id="startDate"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                className="date-input"
                                max={new Date().toISOString().split('T')[0]}
                                required
                            />
                        </div>

                        <div className="form-actions">
                            <button 
                                type="button" 
                                onClick={onClose}
                                className="cancel-btn"
                            >
                                취소
                            </button>
                            <button 
                                type="submit" 
                                disabled={isLoading}
                                className="submit-btn"
                            >
                                {isLoading ? '수정 중...' : '수정하기'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default StartDateEdit;
